import { render } from "./Usage.vue?vue&type=template&id=a9b1b46c&scoped=true"
import script from "./Usage.vue?vue&type=script&lang=ts"
export * from "./Usage.vue?vue&type=script&lang=ts"

import "./Usage.vue?vue&type=style&index=0&id=a9b1b46c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a9b1b46c"

export default script